export const showTestHQBanner = (slug) => {
  const testHQUrls = [
    '/bksb-test',
    '/practice-watson-glaser-test',
    '/cat4-level-d',
    '/cheat-shl-tests',
    '/thomas-gia-test',
    '/korn-ferry-assessment',
    '/iegat-test',
    '/swift-executive-test',
    '/business-reasoning-inventory',
    '/shl-verbal-reasoning',
    '/thomas-international-ppa',
    '/cat4-cognitive-ability-test',
    '/shl-tests',
    '/swift-analysis-test',
    '/cubiks-test',
  ]

  if (testHQUrls.includes(slug)) {
    return true
  }
  return false
}

export default showTestHQBanner
